const APARTMENT_SLUG = {
  comfort: { 'en-us': 'comfort', 'fr-ca': 'confort' },
  confort: { 'en-us': 'comfort', 'fr-ca': 'confort' },
  'comfort-plus': { 'en-us': 'comfort-plus', 'fr-ca': 'confort-plus' },
  'confort-plus': { 'en-us': 'comfort-plus', 'fr-ca': 'confort-plus' },
}

export function apartmentAltPath(locale, pathSlug) {
  const other = locale === 'en-us' ? 'fr-ca' : 'en-us'
  const row = APARTMENT_SLUG[pathSlug]
  const otherSlug = row ? row[other] : pathSlug
  return `/${other}/apartments/${otherSlug}`
}

const OFFER_ALT = {
  'en-us:stay-longer-and-save': '/fr-ca/offers/prolongez-votre-sejour',
  'fr-ca:prolongez-votre-sejour': '/en-us/offers/stay-longer-and-save',
  'en-us:prolongez-votre-sejour': '/fr-ca/offers/prolongez-votre-sejour',
  'fr-ca:stay-longer-and-save': '/en-us/offers/stay-longer-and-save',
  'en-us:detente-en-ville': '/fr-ca/offers/escapade-a-griffintown',
  'fr-ca:escapade-a-griffintown': '/en-us/offers/detente-en-ville',
  'en-us:escapade-a-griffintown': '/fr-ca/offers/escapade-a-griffintown',
  'fr-ca:detente-en-ville': '/en-us/offers/relaxing-in-town',
  'en-us:relaxing-in-town': '/fr-ca/offers/detente-en-ville',
  'fr-ca:relaxing-in-town': '/en-us/offers/relaxing-in-town',
  'en-us:exclusive-offer': '/fr-ca/offers/offre-exclusive',
  'fr-ca:offre-exclusive': '/en-us/offers/exclusive-offer',
  'en-us:offre-exclusive': '/fr-ca/offers/offre-exclusive',
  'fr-ca:exclusive-offer': '/en-us/offers/exclusive-offer',
}

export function offerAltPath(locale, pathSlug) {
  return OFFER_ALT[`${locale}:${pathSlug}`] || null
}
